//Empresas
$(document).on('click','.abreEmpresaModal', function(){
    
    var id = $(this).data('id') || (this.id ? this.id.replace(/^[^\d]+/, '') : null);
    if(!id) return;

    $("#_method").val("PUT");
    $("#formEmpresa").attr('action',"empresas/"+id);
    $("#btnDeleteEmpresa").css("display","block");
    $("#btnDeleteEmpresa").attr('onclick',"document.getElementById('delete-"+id+"').submit()");
    $("#logo").attr('src',"storage/logo/nologo.jpg");
    
    $(".campo").val("");
    $.ajax({
        url: "empresas/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#fichaEmpresaLabel").html("Edición de empresa "+data['nombre']);
            $.each(data,function(index,value){
                if(value != null){
                    if(index == 'logo'){
                        $("#logo").attr('src',"storage/"+data['logo']);
                    }else{
                        $("#"+index.toLowerCase()).val(value);
                    }
                }

            });
        }
    }); 
});
$(document).on('click','.nuevaEmpresaModal', function(){
    $("#_method").val("POST");
    $("#formEmpresa").attr('action',"empresas");
    $("#fichaEmpresaLabel").html("Creación de nueva empresa");
    $("#logo").attr('src',"storage/logo/nologo.jpg");
    $("#btnDeleteEmpresa").css("display","none");
    $(".campo").val("");
});
$(document).on('click','.selectReporte',function(){
    var id = $(this).data('id') || (this.id ? this.id.replace(/^[^\d]+/, '') : null);
    if(!id) return;
    $("#formSelectReporte").attr('action',"empresas/reportes/"+id);
    $("#_method").val("POST");
    $(".campo").val("");

    $.ajax({
        url: "empresas/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#selectReporteLabel").html("Selecciona reporte de la empresa "+data['nombre']);
        }
    }); 
});

// Configuración de Stripe
$(document).on('click', '.openStripeModal', function(e) {
    e.preventDefault();
    var id = $(this).data('id') || (this.id ? this.id.replace(/^[^\d]+/, '') : null);
    if (!id) return;

    $("#stripe_empresa_id").val(id);
    $("#formStripeEmpresa").attr('action', '/empresas/' + id + '/stripe');
    $("#stripe_key").val('');
    $("#stripe_secret").val('').attr('type', 'password');
    $("#stripe_webhook_secret").val('').attr('type', 'password');
    $(".btn-toggle-secret i").removeClass('bi-eye-slash').addClass('bi-eye');
    $("#stripe_activo").prop('checked', false);
    $("#stripe_permitir_suscripciones").prop('checked', false);
    $("#stripe_origen_desc").text('Cargando credenciales...');
    $("#stripe_test_feedback").addClass('d-none').empty();

    $.ajax({
        url: '/empresas/' + id + '/stripe',
        type: 'GET',
        dataType: 'json',
        success: function(data) {
            $("#modalStripeEmpresaLabel").html('Configuración de Stripe &mdash; ' + data.nombre);
            $("#stripe_key").val(data.stripe_key);
            $("#stripe_secret").val(data.stripe_secret);
            $("#stripe_webhook_secret").val(data.stripe_webhook_secret);
            $("#stripe_activo").prop('checked', data.stripe_activo);
            $("#stripe_permitir_suscripciones").prop('checked', data.stripe_permitir_suscripciones);
            $("#stripe_webhook_url").val(data.webhook_url);

            if (data.origen === 'database') {
                $("#stripe_status_banner").removeClass('alert-warning alert-secondary').addClass('alert-success');
                $("#stripe_origen_title").html('<i class="bi bi-database-check me-1 text-success"></i> Credenciales de Base de Datos Activas');
                $("#stripe_origen_desc").text('Este club tiene configuradas y utiliza sus propias claves personalizadas de Stripe.');
            } else if (data.has_env_fallback) {
                $("#stripe_status_banner").removeClass('alert-success alert-secondary').addClass('alert-warning');
                $("#stripe_origen_title").html('<i class="bi bi-file-earmark-code me-1 text-warning"></i> Utilizando claves por defecto (.env)');
                $("#stripe_origen_desc").text('Actualmente está heredando las claves del entorno (.env). Puedes cambiarlas aquí cuando quieras.');
            } else {
                $("#stripe_status_banner").removeClass('alert-success alert-warning').addClass('alert-secondary');
                $("#stripe_origen_title").html('<i class="bi bi-exclamation-circle me-1 text-secondary"></i> Sin claves configuradas');
                $("#stripe_origen_desc").text('Introduce tus claves de Stripe para permitir pagos móviles con tarjeta.');
            }
        },
        error: function() {
            Swal.fire('Error', 'No se pudieron cargar los datos de Stripe de la empresa', 'error');
        }
    });
});

// Comprobar conexión con Stripe en tiempo real
$(document).on('click', '#btnTestStripe', function(e) {
    e.preventDefault();
    var id = $("#stripe_empresa_id").val();
    if (!id) return;

    var btn = $(this);
    var originalHtml = btn.html();
    var feedback = $("#stripe_test_feedback");

    btn.prop('disabled', true).html('<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span><span>Comprobando...</span>');
    feedback.removeClass('d-none alert-success alert-danger alert-warning').addClass('alert alert-info d-flex align-items-center gap-2')
        .html('<span class="spinner-border spinner-border-sm" role="status"></span><span>Contactando con los servidores seguros de Stripe...</span>');

    $.ajax({
        url: '/empresas/' + id + '/stripe-test',
        type: 'GET',
        dataType: 'json',
        success: function(resp) {
            btn.prop('disabled', false).html(originalHtml);
            if (resp.success) {
                feedback.removeClass('alert-info alert-danger alert-warning').addClass('alert alert-success')
                    .html(`
                        <div class="d-flex align-items-start gap-2">
                            <i class="bi bi-check-circle-fill text-success fs-5"></i>
                            <div>
                                <strong class="d-block text-success">${resp.mensaje}</strong>
                                <div class="small text-muted mt-1">
                                    <span class="badge bg-success-subtle text-success border border-success-subtle me-1">${resp.mode_label}</span>
                                    <span class="badge bg-light text-dark border me-1">País: ${resp.country}</span>
                                    <span class="badge bg-light text-dark border">Moneda: ${(resp.currencies || ['EUR']).join(', ')}</span>
                                </div>
                            </div>
                        </div>
                    `);
            } else {
                feedback.removeClass('alert-info alert-success alert-warning').addClass('alert alert-danger')
                    .html(`
                        <div class="d-flex align-items-center gap-2">
                            <i class="bi bi-exclamation-triangle-fill text-danger fs-5"></i>
                            <div><strong>Error de conexión:</strong> ${resp.error || 'No se pudo verificar la cuenta'}</div>
                        </div>
                    `);
            }
        },
        error: function(xhr) {
            btn.prop('disabled', false).html(originalHtml);
            var err = 'Error al conectar con Stripe';
            if (xhr.responseJSON && xhr.responseJSON.error) {
                err = xhr.responseJSON.error;
            } else if (xhr.responseJSON && xhr.responseJSON.message) {
                err = xhr.responseJSON.message;
            }
            feedback.removeClass('alert-info alert-success alert-warning').addClass('alert alert-danger')
                .html(`
                    <div class="d-flex align-items-center gap-2">
                        <i class="bi bi-exclamation-triangle-fill text-danger fs-5"></i>
                        <div><strong>Fallo en la prueba:</strong> ${err}</div>
                    </div>
                `);
        }
    });
});

// Guardar configuración de Stripe
$(document).on('submit', '#formStripeEmpresa', function(e) {
    e.preventDefault();
    var form = $(this);
    var url = form.attr('action');
    var btn = $("#btnGuardarStripe");

    btn.prop('disabled', true).addClass('opacity-50');

    $.ajax({
        url: url,
        type: 'POST',
        data: form.serialize(),
        dataType: 'json',
        success: function(response) {
            btn.prop('disabled', false).removeClass('opacity-50');
            var modalEl = document.getElementById('modalStripeEmpresa');
            var modalInstance = bootstrap.Modal.getInstance(modalEl);
            if (modalInstance) {
                modalInstance.hide();
            }

            Swal.fire({
                icon: 'success',
                title: 'Stripe Configurado',
                text: response.mensaje || 'Configuración guardada correctamente',
                timer: 1500,
                showConfirmButton: false
            });

            setTimeout(function() {
                location.reload();
            }, 1200);
        },
        error: function(xhr) {
            btn.prop('disabled', false).removeClass('opacity-50');
            var msg = 'Ocurrió un error al guardar la configuración';
            if (xhr.responseJSON && xhr.responseJSON.message) {
                msg = xhr.responseJSON.message;
            }
            Swal.fire('Error', msg, 'error');
        }
    });
});

// Toggle ver/ocultar clave secreta
$(document).on('click', '.btn-toggle-secret', function() {
    var input = $(this).closest('.input-group').find('input');
    var icon = $(this).find('i');
    if (input.attr('type') === 'password') {
        input.attr('type', 'text');
        icon.removeClass('bi-eye').addClass('bi-eye-slash');
    } else {
        input.attr('type', 'password');
        icon.removeClass('bi-eye-slash').addClass('bi-eye');
    }
});

// Copiar al portapapeles
$(document).on('click', '.btn-copy-key', function() {
    var target = $(this).data('target');
    var val = $(target).val();
    if (!val) return;
    navigator.clipboard.writeText(val).then(function() {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'Copiado al portapapeles',
            showConfirmButton: false,
            timer: 1200
        });
    });
});

$(document).on('click', '.btn-copy-webhook', function() {
    var val = $("#stripe_webhook_url").val();
    if (!val) return;
    navigator.clipboard.writeText(val).then(function() {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: 'URL del Webhook copiada',
            showConfirmButton: false,
            timer: 1400
        });
    });
});